// extracted by mini-css-extract-plugin
export default {"block":"_c452e220","imageWrapper":"_1749cdd"};